import { Component } from '@theme/component';

/** Opens/closes the technical-drawing lightbox dialog. */
class CrCadDrawing extends Component {
  requiredRefs = ['dialog'];

  connectedCallback() {
    super.connectedCallback();
    this.refs.dialog.addEventListener('click', this.#onDialogClick);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.refs.dialog.removeEventListener('click', this.#onDialogClick);
  }

  open() {
    this.refs.dialog.showModal();
  }

  close() {
    this.refs.dialog.close();
  }

  #onDialogClick = (event) => {
    if (event.target === this.refs.dialog) this.close();
  };
}

if (!customElements.get('cr-cad-drawing')) {
  customElements.define('cr-cad-drawing', CrCadDrawing);
}
